'use client';

import React from 'react';

import { POWER_TYPE_FILTERS } from '@/components/vehicle-search-filters/constants';

import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';
import { DiscoveryFieldTitle } from '@/components/discovery-questions-input/field-title';
import { Field } from '@/components/ui/field';
import { StreamlineCheck } from '@tac/icons/functional/streamline-check';

const ANY_VALUE = POWER_TYPE_FILTERS.ANY.value;

const normalizePowerTypes = (prev: string[], next: string[]): string[] => {
  const anyWasSelected = prev.includes(ANY_VALUE);
  const anyIsSelected = next.includes(ANY_VALUE);

  if (anyIsSelected && !anyWasSelected) {
    return [ANY_VALUE];
  }
  if (anyIsSelected && next.length > 1) {
    return next.filter((v) => v !== ANY_VALUE);
  }
  return next;
};

export const PowerTypeToggles = ({
  powerTypes,
  setPowerTypes,
}: {
  powerTypes: string[];
  setPowerTypes: (powerTypes: string[]) => void;
}) => {
  const handleValueChange = (next: string[]) => {
    setPowerTypes(normalizePowerTypes(powerTypes, next));
  };

  return (
    <Field className="w-full">
      <DiscoveryFieldTitle>Select your preferred power type</DiscoveryFieldTitle>
      <ToggleGroup
        type="multiple"
        value={powerTypes}
        onValueChange={handleValueChange}
        className="flex w-full flex-col gap-3 md:flex-row md:flex-wrap md:items-stretch"
      >
        {Object.values(POWER_TYPE_FILTERS).map(({ label, value }) => (
          <ToggleGroupItem
            key={value}
            value={value}
            className="flex w-full items-center justify-between md:min-w-0 md:flex-1 md:basis-0 md:w-auto"
          >
            {powerTypes.includes(value) && <StreamlineCheck aria-hidden className="size-4" />}
            <span className="min-w-0 flex-1 break-words whitespace-normal text-left">{label}</span>
          </ToggleGroupItem>
        ))}
      </ToggleGroup>
    </Field>
  );
};
